<template>
  <v-list
    v-model:opened="openedNavGroups"
    open-strategy="multiple"
    class="nav-list"
    nav>
    <v-list-group
      v-for="(navItem, navKey) in navItems"
      :key="navKey"
      :value="navKey">
      <template #activator="{ props }">
        <v-list-item
          v-bind="props"
          color="primary"
          :active="isActiveHeader(navItem)"
          :prepend-icon="navItem.icon">
          <span class="nav-group-title">{{ navKey.replace(/-/g, " ") }}</span>
          <v-icon
            v-if="navKey === 'research' && showNewResearch"
            size="x-small"
            color="accent"
            class="ml-2">
            mdi-circle
          </v-icon>
        </v-list-item>
      </template>
      <v-list-item
        v-for="item in navItem.items"
        :key="item.title"
        class="nested-nav-item"
        :class="{
          'pendo-nav-question-bank': item.route?.name === 'question_bank',
          [PENDO_DC.open]: item.route?.name === 'download_center',
          'research-studio-nav-item': item.route?.name === 'research_studio',
        }"
        color="primary"
        :active="isActive(item)"
        :base-color="item.color"
        @click="$emit('navigate', item)">
        {{ item.title }}
        <v-icon
          v-if="
            navKey === 'research' &&
            item.route?.name === 'research_studio' &&
            researchStudioStore.unreadSurveyIds.length > 0
          "
          size="x-small"
          color="accent"
          class="ml-2">
          mdi-circle
        </v-icon>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>

<script>
import { PENDO_DC } from "@/helpers/pendoDownloadCenter";
import { useResearchStudioStore } from "@/stores/ResearchStudioStore";
import { mapStores } from "pinia";
export default {
  name: "NavExpanded",
  props: {
    navItems: {
      type: Object,
      required: true,
    },
    isActiveHeader: {
      type: Function,
      required: true,
    },
    isActive: {
      type: Function,
      required: true,
    },
  },
  emits: ["navigate"],
  setup() {
    return { PENDO_DC };
  },
  data() {
    return {
      openedNavGroups: Object.keys(this.navItems || {}),
    };
  },
  computed: {
    ...mapStores(useResearchStudioStore),
    showNewResearch() {
      return (
        !this.openedNavGroups.includes("research") &&
        this.researchStudioStore.unreadSurveyIds?.length > 0
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-list {
  :deep(.v-list-item__prepend) {
    width: 36px;
    .v-icon {
      opacity: 1;
    }
  }
  :deep(.v-list-item-title) {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.1px;
  }
  .nav-group-title {
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
  .nested-nav-item {
    padding-inline: 42px !important;
    &.research-studio-nav-item {
      padding-inline-end: 16px !important;
    }
  }
}
</style>
